// Русские подписи значений конфигурации пакетов (источник: generator-front)
export const PACK_TYPES = {
  music: 'Музыка',
  movie: 'Кино',
  series: 'Сериалы',
}

export const PACK_STATUSES = {
  new: { label: 'Новый', variant: 'light-primary' },
  pending: { label: 'В очереди', variant: 'light-warning' },
  error: { label: 'Ошибка', variant: 'light-danger' },
  ready: { label: 'Готов', variant: 'light-info' },
  processing: { label: 'Обработка', variant: 'light-secondary' },
  done: { label: 'Завершено', variant: 'light-success' },
}

export const LAYOUTS = {
  simple: 'Простой конфиг раунда',
  preset: 'Пресет пакета',
  round: 'Конфиг раунда',
  all: 'Конфиг всех раундов',
}

export const PACK_PRESETS = {
  melody: 'Угадай мелодию',
  melodyChoice: 'Музыка 1 из 4',
  covers: 'Каверы',
  coverArts: 'Обложки',
  coversAndCoverArts: 'Обложки + Каверы',
  snakes: 'Змейка',
}

export const THEME_TYPES = {
  random: 'Рандом',
  any: 'Любая',
  topic: 'Тематика',
  firstLetters: 'Первые буквы',
  matrix: 'Матрица',
  letterCount: 'Число букв',
  country: 'Страна',
  matrixInitials: 'Матрица (инициалы)',
  matrixWordEdges: 'Матрица (края слов)',
  otherNamingTopics: 'Прочие именные темы',
  wordCount: 'Число слов',
  genres: 'Жанры',
  symbolsInTitle: 'Символы в названии',
  prepositionsInTitle: 'Предлоги в названии',
  releaseYear: 'Год релиза',
  actors: 'Актёры',
  directors: 'Режиссёры',
  awards: 'Награды',
  studio: 'Студия',
  foundationYear: 'Год основания',
  snake: 'Змейка',
}

export const THEME_FORMATS = {
  melody: 'Угадай мелодию',
  covers: 'Каверы',
  coverArts: 'Обложки',
  melodyChoice: 'Музыка 1 из N',
  artistPhotos: 'Фото артистов',
  bandMembers: 'Составы групп',
}

export const CLUSTERS = {
  none: 'Нет',
  rock: 'Рок',
  pop: 'Поп',
  rusrock: 'Русский рок',
  rap: 'Рэп',
}
